interface PopupProps {
	close: any
}
const Popup: React.FC<PopupProps> = ({ close, children }) => {
	return (
		<section className="fixed left-0 top-0 z-[2000] h-full w-full bg-blue/75 p-12 transition duration-150 ease-in-out">
			<div className="mx-auto h-auto w-[95%] bg-white p-8 text-center md:w-[950px]">
				<img
					src={process.env.PUBLIC_URL + "/images/icon-close.svg"}
					alt="Menu"
					loading="lazy"
					width="60"
					height="73"
					className=" left-[50%] top-4 z-10 mx-auto mb-2 -mt-[58px] w-[60px] cursor-pointer rounded-full bg-blue p-2 "
					onClick={close}
				/>
				{children}
			</div>
		</section>
	)
}

export default Popup
